let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7ixMy")).then(() => parcelRequire('kUWXo'));